import { render, staticRenderFns } from "./ExchangeCode.vue?vue&type=template&id=71efa2ca&scoped=true"
import script from "./ExchangeCode.vue?vue&type=script&lang=js"
export * from "./ExchangeCode.vue?vue&type=script&lang=js"
import style0 from "./ExchangeCode.vue?vue&type=style&index=0&id=71efa2ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71efa2ca",
  null
  
)

export default component.exports